import React, { useEffect, useState } from "react";
import "react-multi-carousel/lib/styles.css";
import Layout from "../../components/Layout.js";
import noFound from "../../assets/Images/image-no-found.jpeg";
import { Zoom } from "react-slideshow-image";
import { NavLink, useNavigate, useParams } from "react-router";
import iconLogo from "../../assets/icons/favicon-3.png";

import {
  listeDesproduct,
  listeDesproduct2,
  VisitorCompteurproduct
} from "../../services/produits/ProduitsRequest.js";
import {
  listeCategoriesSansFiltre,
  listeDesCategories
} from "../../services/parametrage/CategorieRequest.js";
import { Pagination } from "@mui/material";
import { listeMarquesSansFiltre } from "../../services/parametrage/MarqueRequest.js";
// import { listeBoutiqueSansFiltre } from "../services/boutiques/BoutiqueRequest.js";

const AllProduits = () => {
  const { params } = useParams();
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 15,
    nombrePage: 1,
    pagePagination: 1
  });

  const [produitList, setProduitList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [marques, setMarques] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMarque, setSelectedMarque] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingBanniere, setLoadingBanniere] = useState(false);
  const [filteredPromotions, setFilteredPromotions] = useState([]);
  const [activeFilter, setActiveFilter] = useState("all");
  const [banniereCategorie, setBanniereCategorie] = useState([]);

  const formatWord = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  };

  const SkeletonPromotion = () => {
    const skeletonItems = Array.from({ length: 18 }); // Nombre d'éléments skeleton à afficher

    return (
      <>
        {skeletonItems.map((_, index) => (
          <div
            key={index}
            className="w-46 bg-white flex flex-col justify-between shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl relative"
          >
            <div className="p-4">
              <div className="skeleton h-40 w-full object-contain rounded-t-xl relative flex justify-center items-center">
                <img src={iconLogo} alt="" className="animate-bounce" />
              </div>
              <div className="skeleton h-3 w-24 my-2"></div>
              <div className="skeleton h-3 w-28 my-2"></div>

              <div className="skeleton h-3 w-32 my-2"></div>
            </div>

            <h2 className="skeleton rounded-lg px-2 py-2 w-8 h-8 absolute top-1 right-1"></h2>
          </div>
        ))}
      </>
    );
  };

  const counterVisitorClick = (id) => {
    VisitorCompteurproduct(id)
      .then((res) => {
        console.log(res.data);
        navigate(`/product-details/${id}`);
        console.log("compteur incrementé");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const getListeDesCategories = () => {
    setLoading(true);
    listeCategoriesSansFiltre()
      .then((res) => {
        setCategories(res.data.categories);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const getListeDesMarques = () => {
    setLoading(true);
    listeMarquesSansFiltre()
      .then((res) => {
        setMarques(res.data.marques);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const calculateTimeLeft = (expirationDate) => {
    const now = Date.now(); // timestamp actuel en ms
    const end = new Date(expirationDate).getTime(); // timestamp de la date d'expiration
    const difference = end - now; // ms restants

    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)), // jours restants
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24), // heures restantes
        minutes: Math.floor((difference / (1000 * 60)) % 60), // minutes restantes
        seconds: Math.floor((difference / 1000) % 60), // secondes restantes
        isExpired: false
      };
    }

    // Échu
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      isExpired: true
    };
  };

  const filterPromotions = (filterType) => {
    setActiveFilter(filterType);

    let filtered = [];

    switch (filterType) {
      case "current":
        filtered = produitList.filter((promo) => {
          // on ne passe plus que l'expirationDate
          const timeLeft = calculateTimeLeft(promo.expirationDate);
          return !timeLeft.isExpired;
        });
        break;

      case "popular":
        filtered = produitList.filter(
          (promo) => (promo.visitorCount || 0) > 10
        );
        break;

      case "expired":
        filtered = produitList.filter((promo) => {
          const timeLeft = calculateTimeLeft(promo.expirationDate);
          return timeLeft.isExpired;
        });
        break;

      default:
        filtered = produitList;
        break;
    }

    setFilteredPromotions(filtered);
  };

  const PromotionCard = ({ item }) => {
    const [timeLeft, setTimeLeft] = useState(
      calculateTimeLeft(item.expirationDate)
    );
    const now = Date.now(); // timestamp actuel en ms

    const dateFinPromo = new Date(item.finSolde).getTime();
    useEffect(() => {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft(item.finSolde));
      }, 1000);

      return () => clearInterval(timer);
    }, [item]);

    return (
      <div
        onClick={() => counterVisitorClick(item._id)}
        className="w-44 cursor-pointer bg-white flex flex-col justify-between shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl relative"
      >
        <div className="">
          <img
            src={item.images[0]}
            alt="Product"
            className="h-40 w-full object-contain rounded-t-xl"
          />
          <div className="flex flex-row justify-between items-center px-4 w-44">
            <span className="text-gray-400 mr-3 uppercase text-xs">
              {item.marque && item.marque.nom}
            </span>
          </div>
          <div className="px-4 py-1 flex flex-col w-full">
            <h3 className="text-sm font-medium truncate">{item.name}</h3>
          </div>
        </div>

        <div className="flex flex-col justify-start items-start px-4 ">
          <h2 className="text-md text-secondary font-semibold">
            {item.prixSolde ? (
              <h2>{item.prix - item.prixSolde} FCFA</h2>
            ) : (
              <h2>{item.prix} FCFA</h2>
            )}
          </h2>
          {item.prixSolde && <del className="">{item.prix} FCFA</del>}
        </div>
        <div className="flex flex-col justify-between items-start px-4 py-1">
          {dateFinPromo > now ? (
            <div className="w-full">
              <h3 className="text-sm font-semibold text-gray-800">
                Promotion Expire dans :
              </h3>
              <div className="grid grid-flow-col gap-2 mt-1 text-center auto-cols-max">
                <div className="flex flex-col p-1 bg-neutral rounded-lg text-neutral-content">
                  <span className="countdown font-mono text-sm">
                    <span style={{ "--value": timeLeft.days }}></span>
                  </span>
                  <span className="text-xs">Jrs</span>
                </div>
                <div className="flex flex-col p-1 bg-neutral rounded-lg text-neutral-content">
                  <span className="countdown font-mono text-sm">
                    <span style={{ "--value": timeLeft.hours }}></span>
                  </span>
                  <span className="text-xs">Hrs</span>
                </div>
                <div className="flex flex-col p-1 bg-neutral rounded-lg text-neutral-content">
                  <span className="countdown font-mono text-sm">
                    <span style={{ "--value": timeLeft.minutes }}></span>
                  </span>
                  <span className="text-xs">Min</span>
                </div>
                <div className="flex flex-col p-1 bg-neutral rounded-lg text-neutral-content">
                  <span className="countdown font-mono text-sm">
                    <span style={{ "--value": timeLeft.seconds }}></span>
                  </span>
                  <span className="text-xs">Sec</span>
                </div>
              </div>
            </div>
          ) : (
            " "
          )}
          <h3 className="text-gray-400 text-sm mt-2">
            + {item.visitorCount || 0} visiteurs
          </h3>
        </div>

        <h2 className="text-lg font-bold bg-[#ffffffc0] rounded-lg px-2 py-2 text-primary block capitalize absolute top-1 right-1">
          - {item.pourcentageSolde && item.pourcentageSolde} %
        </h2>
      </div>
    );
  };

  // === PAGINATION DES ELEMENTS ===
  const handlePaginationChange = (event, value) => {
    window.scrollTo(0, 0); // Scroll en haut
    setLoading(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value
    }));

    // Déterminer le paramètre à utiliser pour l'API
    let apiParam = params;

    // Si selectedMarque n'est pas null, l'utiliser comme paramètre principal
    if (selectedMarque !== null) {
      apiParam = selectedMarque;
    }

    if (params !== "enSolde") {
      listeDesproduct2(value, pageQuery.size, apiParam)
        .then((res) => {
          setLoading(false);
          let filteredProducts = res.data.products;

          // Si on filtre par marque ET qu'on a une catégorie, appliquer un filtre côté client
          if (selectedMarque !== null && params !== "enSolde") {
            filteredProducts = res.data.products.filter(
              (item) => item.categorie && item.categorie.nom === params
            );
          }
          // Si aucun produit n'est trouvé, forcer la pagination à 1 page
          if (filteredProducts.length === 0) {
            setProduitList([]);
            setPageQuery((prev) => ({
              ...prev,
              nombrePage: 1,
              totalElements: 0
            }));
          } else {
            setProduitList(filteredProducts);
            setPageQuery((prev) => ({
              ...prev,
              nombrePage: res.data.totalPages,
              totalElements: res.data.totalPromotions
            }));
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("error", error);
        });
    } else {
      listeDesproduct(value, pageQuery.size, apiParam, true)
        .then((res) => {
          setLoading(false);
          setProduitList(res.data.products);
          setPageQuery((prev) => ({
            ...prev,
            nombrePage: res.data.totalPages,
            totalElements: res.data.totalPromotions
          }));
        })
        .catch((error) => {
          setLoading(false);
          console.log("error", error);
        });
    }
  };

  const handleCategoryChange = (nom) => {
    if (nom !== params) {
      window.scrollTo(0, 0); // Scroll en haut
      setSelectedMarque(null);
      setSelectedCategory(nom); // Mettre à jour l'état de la catégorie sélectionnée
      setLoading(true);
      // Remettre la pagination à la première page
      setPageQuery((prev) => ({
        ...prev,
        page: 0,
        pagePagination: 1
      }));
      navigate(`/allproduits/${nom}`);
    }
  };

  const handleMarqueChange = (nom) => {
    console.log("params :", params);
    console.log("marques :", nom);

    if (
      marques.find(
        (marque) => marque.nom.toLowerCase() === params.toLowerCase()
      )
    ) {
      navigate(`/allproduits/${nom}`);
    } else {
      window.scrollTo(0, 0); // Scroll en haut
      setSelectedMarque(nom); // Mettre à jour l'état de la marque sélectionnée
      setSelectedCategory(null); // Clear category selection when brand changes
      setLoading(true);
      // Remettre la pagination à la première page
      setPageQuery((prev) => ({
        ...prev,
        page: 0,
        pagePagination: 1
      }));
    }
    // Le useEffect va maintenant gérer la récupération des données basée sur selectedMarque
  };

  useEffect(() => {
    setLoading(true);
    setLoadingBanniere(true);
    // Déterminer le paramètre à utiliser pour l'API
    let apiParam = params;

    // Si selectedMarque n'est pas null, l'utiliser comme paramètre principal
    if (selectedMarque !== null) {
      apiParam = selectedMarque;
    }

    if (params !== "enSolde") {
      listeDesproduct2(pageQuery.page, pageQuery.size, apiParam)
        .then((res) => {
          setLoading(false);
          let filteredProducts = res.data.products;
          // Si on filtre par marque ET qu'on a une catégorie, appliquer un filtre côté client
          if (selectedMarque !== null && params !== "enSolde") {
            filteredProducts = res.data.products.filter(
              (item) => item.categorie && item.categorie.nom === params
            );
          }

          // Si aucun produit n'est trouvé, forcer la pagination à 1 page
          if (filteredProducts.length === 0) {
            setProduitList([]);
            setPageQuery((prev) => ({
              ...prev,
              nombrePage: 1,
              totalElements: 0
            }));
          } else {
            setProduitList(filteredProducts);
            setPageQuery((prev) => ({
              ...prev,
              nombrePage: res.data.totalPages,
              totalElements: res.data.totalPromotions
            }));
          }
        })
        .catch((error) => {
          console.log("error", error);
          setLoading(false);
        });
      listeDesCategories(pageQuery.page, pageQuery.size, params)
        .then((res) => {
          setLoadingBanniere(false);
          const bannieresNonVides = (
            res.data.categories?.[0]?.imageBannieres ?? []
          ).filter((url) => typeof url === "string" && url.trim());
          setBanniereCategorie(bannieresNonVides);
        })
        .catch((error) => {
          setLoadingBanniere(false);
          console.log("error", error);
        });
    } else if (selectedMarque !== null) {
      listeDesproduct(pageQuery.page, pageQuery.size, apiParam, true)
        .then((res) => {
          setLoading(false);
          let filteredProducts = res.data.products;
          // Si on filtre par marque ET qu'on a une catégorie, appliquer un filtre côté client
          if (selectedMarque !== null && params !== "enSolde") {
            filteredProducts = res.data.products.filter(
              (item) => item.categorie && item.categorie.nom === params
            );
          }
          // Si aucun produit n'est trouvé, forcer la pagination à 1 page
          if (filteredProducts.length === 0) {
            setProduitList([]);
            setPageQuery((prev) => ({
              ...prev,
              nombrePage: 1,
              totalElements: 0
            }));
          } else {
            setProduitList(filteredProducts);
            setPageQuery((prev) => ({
              ...prev,
              nombrePage: res.data.totalPages,
              totalElements: res.data.totalPromotions
            }));
          }
          // setProduitList(res.data.products);
          // setPageQuery((prev) => ({
          //   ...prev,
          //   nombrePage: res.data.totalPages,
          //   totalElements: res.data.totalPromotions
          // }));
        })
        .catch((error) => {
          console.log("error", error);
          setLoading(false);
        });
    } else {
      listeDesproduct(pageQuery.page, pageQuery.size, "", true)
        .then((res) => {
          setLoading(false);
          setProduitList(res.data.products);
          setPageQuery((prev) => ({
            ...prev,
            nombrePage: res.data.totalPages,
            totalElements: res.data.totalPromotions
          }));
        })
        .catch((error) => {
          console.log("error", error);
          setLoading(false);
        });
    }
  }, [params, selectedMarque, pageQuery.page, pageQuery.size]);

  // console.log("banniereCategorie :", banniereCategorie);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll en haut
  }, []);

  useEffect(() => {
    getListeDesCategories();
    getListeDesMarques();
  }, []);

  useEffect(() => {
    filterPromotions(activeFilter);
  }, [produitList]);

  return (
    <Layout>
      <div className="min-h-screen w-full px-2 sm:px-4 py-2">
        <div className="breadcrumbs flex flex-row justify-start w-full text-sm lg:px-12 md:px-12 px-2">
          <ul>
            <li>
              <a href="/">Accueil</a>
            </li>
            <li>
              {params === "enSolde" ? "Articles en Flash promo" : params}{" "}
            </li>
            {selectedMarque !== null ? <li>{selectedMarque}</li> : null}
          </ul>
        </div>

        {/* <div className="skeleton w-full h-[200px] rounded-t-xl"></div> */}

        <div className="my-5 w-full lg:px-12 md:px-12 px-2">
          {banniereCategorie.length > 1 && !loadingBanniere ? (
            <Zoom scale={1.4} arrows={false} indicators={false}>
              {banniereCategorie.map((each, index) => (
                <div
                  key={index}
                  className="w-full lg:h-[50%] xl:h-[50%] h-[90%] "
                >
                  <img
                    className="object-cover w-full"
                    alt="Slide-Image"
                    src={each}
                  />
                </div>
              ))}
            </Zoom>
          ) : banniereCategorie.length === 1 && !loadingBanniere ? (
            <img
              className="object-cover w-full"
              alt="Slide-Image"
              src={banniereCategorie[0]}
            />
          ) : banniereCategorie.length >= 1 && loadingBanniere ? (
            <div className="skeleton w-full h-[400px] rounded-t-xl"></div>
          ) : null}
        </div>

        <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 lg:px-12 md:px-12 px-2 mt-[2rem]">
          {/* Catégories à gauche */}
          <div className="lg:block xl:block hidden w-full lg:w-[250px] bg-white rounded-lg shadow-md p-4 h-fit">
            <div>
              <h2 className="text-lg font-semibold mb-4">Catégories</h2>
              {/* Sélecteur pour mobile */}
              {/* Liste des boutons pour desktop */}
              <div className="hidden lg:flex flex-col gap-1">
                {/* <button>Toutes les catégories</button> */}
                {categories.map((category) => (
                  <button
                    key={category._id}
                    onClick={() => {
                      handleCategoryChange(category.nom);
                    }}
                    className={`text-left px-4 py-1 rounded-lg ${
                      selectedCategory === category._id
                        ? "bg-primary text-white"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    {formatWord(category.nom)}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <h2 className="text-lg font-semibold mb-4">Marques</h2>
              {/* Liste des boutons pour desktop */}
              <div className="hidden lg:flex flex-col gap-1">
                {/* <button>Toutes les catégories</button> */}
                {marques.map((marque) => (
                  <button
                    key={marque._id}
                    onClick={() => handleMarqueChange(marque.nom)}
                    className={`text-left px-4 py-1 rounded-lg ${
                      selectedMarque === marque._id
                        ? "bg-primary text-white"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    {formatWord(marque.nom)}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:hidden flex flex-row w-full justify-start items-center gap-2">
            {/* Sélecteur pour mobile */}
            <select
              className="border border-gray-300 w-[130px] py-3 px-2 bg-white rounded-lg"
              value={selectedMarque || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                  setSelectedMarque(null);
                  setLoading(true);
                  listeDesproduct(pageQuery.page, pageQuery.size, value, true)
                    .then((res) => {
                      setLoading(false);
                      setProduitList(res.data.products);
                      setPageQuery((prev) => ({
                        ...prev,
                        nombrePage: res.data.totalPages,
                        totalElements: res.data.totalPromotions
                      }));
                    })
                    .catch((error) => {
                      console.log("error", error);
                      setLoading(false);
                    });
                } else {
                  handleMarqueChange(value);
                }
              }}
            >
              <option className="bg-slate-300" value="">
                Marques
              </option>
              {marques.map((marque) => (
                <option
                  className="cursor-pointer"
                  key={marque._id}
                  value={marque.nom}
                >
                  {marque.nom}
                </option>
              ))}
            </select>

            <select
              className="border border-gray-300 w-[130px] py-3 px-2 bg-white rounded-lg"
              value={selectedCategory || ""}
              onChange={(e) => {
                const value = e.target.value;
                handleCategoryChange(value);
              }}
            >
              <option disabled value="">
                Catégories
              </option>
              {categories.map((category) => (
                <option key={category._id} value={category.nom}>
                  {category.nom}
                </option>
              ))}
            </select>
          </div>

          {/* Contenu principal */}
          <div className="w-full lg:w-3/4">
            {/* Filtres en haut */}
            <div className="shadow-lg py-3 bg-white px-2 rounded-lg">
              <h2 className="flex flex-row justify-start items-center gap-3 font-semibold text-lg">
                {params === "enSolde" ? "Articles en Flash promo" : params}{" "}
                {selectedMarque && selectedMarque !== null ? (
                  <span className="text-gray-400 font-medium">
                    ({produitList.length}){` / ${selectedMarque}`}
                  </span>
                ) : (
                  <span className="text-gray-400 font-medium">
                    ({produitList.length})
                  </span>
                )}
              </h2>
            </div>

            <div className="w-full grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 justify-center gap-y-10 gap-x-5 mt-10 mb-5">
              {filteredPromotions.length > 0 && !loading ? (
                filteredPromotions.map((item, i) => (
                  <PromotionCard key={i} item={item} />
                ))
              ) : produitList.length === 0 && loading ? (
                <SkeletonPromotion />
              ) : (
                // <h2 className="text-center text-lg font-bold text-gray-400 col-span-full">
                //   Aucun article disponible{" "}
                // </h2>
                <div className="w-full grid col-span-full  items-center justify-center">
                  <img src={noFound} alt="" className="w-64" />
                </div>
              )}
            </div>

            <div className="flex justify-center mt-2">
              <Pagination
                count={pageQuery.nombrePage}
                page={pageQuery.pagePagination}
                variant="outlined"
                shape="rounded"
                onChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AllProduits;
